import { syncAvatarMenuState } from './authGateController';
import { primeProfileFirstFrame } from './profileHydrator';
import type { PrototypeState } from './prototypeHydration';
import type { Root } from './prototypeTypes';

/** Paints only state that is already proven by the server-rendered session model. */
export function primeRefreshFirstFrame(root: Root, state: PrototypeState): void {
	syncAvatarMenuState(root, state);
	primeProfileFirstFrame(root, {
		isLoggedIn: state.isLoggedIn,
		plan: state.effectiveAccessPlan,
		avatarInitials: state.runtime.userDisplayName,
	});
}
